'use strict';

var HideIfFeatureDirective = function HideIfFeatureDirective(featureToggleService) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 999,
    link: function link(scope, element, attrs, ctrl, $transclude) {
      var featureName = attrs.rmHideIfFeature;
      if (featureToggleService.isDisabled(featureName)) {
        $transclude(scope.$new(), function (clone) {
          element.after(clone).remove();
        });
      }
    }
  };
};
HideIfFeatureDirective.$inject = ['FeatureToggleService'];
module.exports = HideIfFeatureDirective;